import type { ApiError } from '../shared/api.ts';

/** getElementById that fails loudly instead of returning null. */
export function $<T extends Element = HTMLElement>(id: string): T {
  const el = document.getElementById(id);
  if (!el) throw new Error(`#${id} not found`);
  return el as unknown as T;
}

const ESC: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
export const esc = (s: unknown) => String(s).replace(/[&<>"']/g, (c) => ESC[c] ?? c);

/** fetch + JSON with the API's { error } shape turned into a thrown Error. */
export async function api<T>(path: string, opts: RequestInit = {}): Promise<T> {
  const res = await fetch(path, opts);
  const isJson = res.headers.get('content-type')?.includes('json');
  const body: unknown = isJson ? await res.json() : await res.text();
  if (!res.ok) {
    const err = body as Partial<ApiError> | string;
    const msg = typeof err === 'string' ? err : err.issues?.length ? err.issues.map((i) => `${i.path}: ${i.message}`).join(', ') : err.error;
    throw new Error(msg || res.statusText);
  }
  return body as T;
}

let toastTimer: ReturnType<typeof setTimeout> | undefined;
export function toast(msg: string, isError = false): void {
  const t = $('toast');
  t.textContent = msg;
  t.className = `toast show${isError ? ' err' : ''}`;
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => (t.className = 'toast'), isError ? 4500 : 2200);
}
